import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {Store} from '@softline/core';
import {SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_ERSTELLEN} from '../pruefprotokoll.shared';
import {PruefprotokollErstellenStore} from '../store/pruefprotokoll-erstellen.store';

export const aktivitaetStepGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const state = inject(Store).get(
    SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_ERSTELLEN,
    PruefprotokollErstellenStore.getters.state
  );

  if (state?.lagerplatz)
    return true;
  else
    return router.navigate(['/pruefprotokoll/erstellen/lagerplatz']);
}
